import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */
import React, { useState } from "react";
import utils from "Root/profile/utils";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import { useHistory } from "react-router";
import { ORDER_HISTORY_PATH, BASE } from "Root/profile/ProfileRoutes";
import IconButton from "@mui/material/IconButton";
import { MoreVert } from "@mui/icons-material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import styles from "./style.module.scss";
import H3Font from "../../common/H3Font";
import LargeFont from "../../common/LargeFont";
import Button from "../../common/Button";
const AccountOrderStatus = ({ items, order_date, status, tracking_url }) => {
    const orderStatusStyle = status && utils.getOrderStatusStyles(status);
    const screenWidth = useScreenWidth();
    const isExtraMobile = screenWidth < 320;
    const isSmallMobile = screenWidth >= 320 && screenWidth < 410;
    const isMobile = screenWidth >= 410 && screenWidth < 490;
    const isXLMobile = screenWidth >= 490 && screenWidth < 600;
    const isXXLMobile = screenWidth >= 600 && screenWidth < 768;
    const isTablet = screenWidth >= 768 && screenWidth < 900;
    const isSmallDesktop = screenWidth >= 900 && screenWidth < 1024;
    const isDesktop = screenWidth >= 1024 && screenWidth < 1200;
    const isLargeDesktop = screenWidth >= 1200;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showAllItems, setShowAllItems] = useState(false);
    const open = Boolean(anchorEl);
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const trackOrder = () => {
        if (tracking_url) {
            window.location.href = tracking_url;
        }
    };
    const inTransit = status === "In Transit";
    const getItemsToDisplay = () => {
        let trunc = 0;
        if (isExtraMobile) {
            trunc = 1;
        }
        if (isSmallMobile) {
            trunc = 3;
        }
        if (isMobile) {
            trunc = 4;
        }
        if (isXLMobile) {
            trunc = 5;
        }
        if (isXXLMobile) {
            trunc = 6;
        }
        if (isTablet) {
            trunc = 4;
        }
        if (isSmallDesktop) {
            trunc = 5;
        }
        if (isDesktop) {
            trunc = 6;
        }
        if (isLargeDesktop) {
            trunc = 7;
        }
        const arr = items.length >= trunc ? items.slice(0, trunc) : items;
        const remainingCounter = items.length - trunc;
        return {
            arr: arr || items,
            remainingCounter: remainingCounter || 0,
        };
    };
    const history = useHistory();
    const goToOrderHistory = () => history.push(BASE + ORDER_HISTORY_PATH);
    const goToFutureOrders = () => history.push("/app/order-history#future_orders");
    const getOrderNow = () => history.push("/app/reactivation/confirm#now", { prevPath: "/app/home" });
    const getStatus = () => {
        if (status === "In Progress") {
            return "Order Processing";
        }
        if (status === "In Transit") {
            return "Order Shipped";
        }
        return "Upcoming Order";
    };
    const itemsToDisplay = showAllItems ? items : getItemsToDisplay().arr;
    return orderStatusStyle ? (_jsx("div", { className: styles.account_order_status_content, children: _jsx("div", { className: styles.account_order_status_wrapper_mob, children: _jsxs("div", { className: styles.account_order_status_details_wrapper_mob, children: [_jsxs("div", { className: styles.account_order_status_info_mob, children: [_jsxs("div", { className: styles.account_order_info_wrapper, children: [_jsx(H3Font, { color: orderStatusStyle.color, children: getStatus() }), _jsxs(LargeFont, { children: [order_date, " Order"] }), _jsx("div", { style: { background: orderStatusStyle.backgroundColor }, className: styles.account_hint_bar })] }), _jsx(IconButton, { "data-attr": "order-status-three-dots-button", onClick: handleClick, children: _jsx(MoreVert, {}) }), _jsxs(Menu, { id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                                    "aria-labelledby": "basic-button",
                                }, children: [tracking_url && inTransit && _jsx(MenuItem, { onClick: trackOrder, children: "Order Tracking" }), _jsx(MenuItem, { "data-attr": "order-status-three-dots-order-history-link", onClick: goToOrderHistory, children: "Order History" }), getStatus() === "Upcoming Order" && (_jsx(MenuItem, { "data-attr": "order-status-three-dots-order-now-link", onClick: getOrderNow, children: "Get Order Now" }))] })] }), _jsxs("div", { className: styles.account_order_items_wrapper_mob, children: [items &&
                                itemsToDisplay.map((item) => (_jsx("div", { className: styles.account_order_item_img_mob, children: _jsx("img", { src: item.image_url, alt: item.title }) }, item.title + item.image_url))), showAllItems && (_jsx(Button, { variant: "secondary", underlined: true, onClick: () => setShowAllItems(false), children: "Show Less" })), getItemsToDisplay().remainingCounter <= 0 || showAllItems ? null : (_jsx("div", { onClick: () => setShowAllItems(true), role: "button", onKeyDown: () => null, tabIndex: 0, className: styles.account_order_unvisible_items_mob, children: _jsxs("span", { className: styles.plusText, children: ["+", getItemsToDisplay().remainingCounter] }) }))] })] }) }) })) : null;
};
export default AccountOrderStatus;
